import React from "react";
import { LOCK_PRESETS, XP_DISCLAIMER } from "../../config/supernovaXp";
import { fmtMultiplier } from "./supernovaFormat";

/**
 * "How staking works" — what staking actually does, in the member's words.
 *
 * The v4 redesign collapses this behind a summary rather than parking it above
 * the collection: it is reference, not news, and the member who wants it opens
 * it. The disclosure element itself belongs to SupernovaTab; this is its body.
 *
 * Copy is the mockup's, with the numbers read out of config (LOCK_PRESETS)
 * rather than typed into the sentence, so the explainer can't drift from the
 * model the rest of the tab computes with.
 *
 * COMPLIANCE: everything described here is XP — an in-app points balance with
 * no monetary value, stated inline. "Earn" and "rate" refer to points per day
 * and to nothing else. No return, yield, income, or dollar figure appears on
 * this surface, and none may be added to it.
 */

const SupernovaGateExplainer = () => {
  const shortest = LOCK_PRESETS[0];
  const longest = LOCK_PRESETS[LOCK_PRESETS.length - 1];

  return (
    <div className="sn-details-body" data-testid="supernova-gate-explainer">
      <p>
        <b className="text-arc-accent-ink">
          Each Supernova you stake unlocks 1 automated strategy slot
        </b>{" "}
        — on any venue the engine supports, now or later. XP accrues{" "}
        <b className="text-arc-accent-ink">daily</b>, and longer locks earn points
        faster: {fmtMultiplier(shortest.multiplier)} at {shortest.label} up to{" "}
        <b className="text-arc-accent-ink">
          {fmtMultiplier(longest.multiplier)} at {longest.label}
        </b>
        . Hold to maturity and keep every point at your full rate. Exit early and
        you keep only what the lock you <i>actually completed</i> would have
        earned — re-rated down to that tier&apos;s rate — minus a penalty that
        starts large and shrinks to zero at your unlock date. The full table and
        a live preview appear when you choose a duration. Cash allocations never
        need a stake.
      </p>
      <p className="text-caption text-arc-ink-4 mt-2.5">{XP_DISCLAIMER}</p>
    </div>
  );
};

export default SupernovaGateExplainer;
